/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import { FeedbackEmailRequestModel } from "~/project/AramcoLife/generated-types";
import { ApiResponse } from "~/foundation/Api/generated-types";

export const feedbackServiceMeta: Meta<typeof feedbackService> = {
	sendFeedback: ["POST", "/api/v1/feedback/sendfeedback"],
};

// Project.AramcoLife.Controllers.Api.ApiV1FeedbackController
export const feedbackService = {
	async sendFeedback(body: FeedbackEmailRequestModel) {
		return await http.fetch<ApiResponse, FeedbackEmailRequestModel>(feedbackServiceMeta.sendFeedback, { body });
	},
};
